import { deleteCostApi } from "./deleteCostApi";

export const deleteCostSetData = async (
  lang,
  setMessageResponse,
  cookies,
  cost_id,
  setSuccessMessage
) => {
  const response = await deleteCostApi(cost_id, lang, cookies);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      data: response.res.data,
    }));
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
    }
  }
};
